var map = {
	"./ai.svg": "3db8",
	"./figma.svg": "6299",
	"./otf.svg": "047a",
	"./pdf.svg": "c098",
	"./png.svg": "5aa8",
	"./ttf.svg": "0c04",
	"./woff.svg": "4af5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "de32";